export interface Contact {
  id: number;
  email: string;
  type: string;
  disabled?: boolean; 
  requestDate?: string; 
}

export interface FormValues {
  contacts: Contact[];
  comment: string;
}



export interface SuggestedRole {
  role: string;
  roleDescription: string;
}

export interface Feedback360Summary {
  id: number;
  observedStrengths: string;
  developmentAreas: string;
  suggestedRoles: SuggestedRole[];
}

export enum ModalState {
  CLOSED,
  SUCCESS,
}

export interface Feedback360Item {
  email: string;
  type: string;
}

export interface CreateFeedback360Request {
  items: Feedback360Item[];
  comment?: string;
}

export interface Feedback360Response {
  email: string;
  type: string;
  requestDate: string;
}

export interface AddFeedback360Request {
  items: Feedback360Item[];
  comment?: string;
}
